import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertCircleFill } from '@lyearn/icons';
import { Box, Stack, Tooltip, Typography } from '@lyearn/ui';

import { useScorecard } from '../Scorecard';
import { QuestionsMarkedProps } from '../types';

function QuestionsMarked(props: QuestionsMarkedProps) {
  const {
    variant = 'body-short-02',
    color = 'text-text-secondary',
    className,
    markedQuestionLength,
    isError,
  } = props;
  const [scorecard] = useScorecard();
  const { t } = useTranslation('Exercise');

  if (!scorecard?.questions) {
    return null;
  }

  const totalQuestions = scorecard?.questions?.length;

  return (
    <Stack alignItems="center" className={className} gapX={8}>
      <Typography color={isError ? 'text-text-error' : color} variant={variant}>
        {t('Exercise:QuestionsFilled', { filled: markedQuestionLength, total: totalQuestions })}
      </Typography>
      {isError ? (
        <Tooltip placement="right" title={`${t('Exercise:ScorecardIncomplete')}`}>
          <Box>
            <AlertCircleFill fillColorToken="icon-error" height="20" width="20" />
          </Box>
        </Tooltip>
      ) : null}
    </Stack>
  );
}

export default React.memo(QuestionsMarked);
